// extracted by mini-css-extract-plugin
export default {"pi_item_img":"po_item_table_pi_item_img__hop5d"};